import { render, staticRenderFns } from "./Form2_Empresa.vue?vue&type=template&id=f729372e"
import script from "./Form2_Empresa.vue?vue&type=script&lang=js"
export * from "./Form2_Empresa.vue?vue&type=script&lang=js"
import style0 from "./Form2_Empresa.vue?vue&type=style&index=0&id=f729372e&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f729372e')) {
      api.createRecord('f729372e', component.options)
    } else {
      api.reload('f729372e', component.options)
    }
    module.hot.accept("./Form2_Empresa.vue?vue&type=template&id=f729372e", function () {
      api.rerender('f729372e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/MX/Form2_Empresa.vue"
export default component.exports